import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Routes from "./routes/index";
import rootSaga from "./sagas";
import configStore from "./stores";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import IdleTimerProvider from "./contexts/IdleTimerProvider";

const { runSaga, store, persistor } = configStore();

runSaga(rootSaga);

const App = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={<div />} persistor={persistor}>
        <IdleTimerProvider store={store}>
          <Router>
            <Routes />
          </Router>
        </IdleTimerProvider>
      </PersistGate>
    </Provider>
  );
};

export default App;
